// extracted by css-extract-rspack-plugin
export default {"navCategory":"_850e358d","isSelected":"_250d757"};